<template>
  <div>
    <n-bar title="充值" :top="true" :on-click-home="home"/>
    <div style="display: flex;justify-content: center;">
      <div class="list-div">
        <div @click="itemClick(index)" class="item" :class="itemIndex == index ? 'on' : ''"
             v-for="(item, index) in list"
             :key="index">
          <nut-price :price="item.recharge" style="zoom: 1.5;" :decimalDigits="2" :needSymbol="true"
                     :thousands="true"/>
          <div>
            <span style="color: #9B9B9B;padding: 1px 5px;font-size: 14px;">赠送</span>
            <nut-price :price="item.money" style="zoom: 0.9;color: #9B9B9B;" :decimalDigits="2" :needSymbol="true"
                       :thousands="true"/>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 40px;text-align: center;">
      <nut-button @click="pay" shape="circle" style="width: 80%;">充值</nut-button>
    </div>
    <pay v-model="payShow" :price="list.length > 0 ? Number(list[itemIndex].recharge) : 0"
         :pay-price="list.length > 0 ? Number(list[itemIndex].recharge) : 0"
         :pay-type="2" :data="data" :show-balance="false" :show-card="false"></pay>
  </div>
</template>

<script>
/**
 * 会员充值
 */
export default {
  name: 'DeviceRecharge',
  data () {
    return {
      itemIndex: 0,
      list: [],
      payShow: false,
      data: {},
    }
  },
  activated () {
    this.getData()
  },
  methods: {
    home () {
      let deviceId = localStorage.getItem('deviceId')
      this.$router.push(`/device/DeviceUse?deviceId=${deviceId}`)
    },
    getData () {
      this.$api.post({
        url: '/device/api/device/device-config/find'
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          if (!this.$util.isArrOrNull(res.data.rechargeRule)) {
            this.list = JSON.parse(res.data.rechargeRule)
          }
        }
      })
    },
    itemClick (index) {
      this.itemIndex = index
    },
    pay () {
      this.data = {
        uid: this.$api.user.uid,
        money: this.list[this.itemIndex].recharge,
        giveMoney: this.list[this.itemIndex].money,
        merId: this.$api.merId,
        storeId: this.$api.storeId,
        agentId: this.$api.agentId,
        deviceId : localStorage.getItem('deviceId')
      }
      this.payShow = true
    }
  }
}
</script>

<style scoped>

  .list-div {
    display: flex;
    /*justify-content: space-around;*/
    flex-wrap: wrap;
  }

  .list-div .item {
    margin: 15px 7px 0 7px;
    padding: 10px 0;
    width: 45%;
    background-color: white;
    border: 1px solid white;
    border-radius: 10px;
    text-align: center;
    color: #d81e06;
    display: flex;
    flex-direction: column;
  }

  .list-div .item.on {
    border: 1px solid #d81e06;
    color: #d81e06;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/home/DeviceRecharge.vue